import React from 'react';
import numeral from 'numeraljs';
import { css } from 'styled-components';
import { useQuery } from 'react-fetching-library';
import idx from 'idx';

import { useTranslation } from '../../common/libs/i18n';

import { StatsWrapper } from './Styled';
import { Container, Margin } from '../../common/base';
import { Grid, Col } from '../../common/interfaces';

const HomeStats = () => {
  const { t } = useTranslation();
  const { loading: loadingSupply, payload: resultSupply } = useQuery({
    method: 'GET',
    endpoint: '/v3/supply/all'
  });
  const totalSupply = idx(resultSupply, _ => _.payload.supply) || 700000000;
  const { loading: loadingVolume, payload: resultVolume } = useQuery({
    method: 'GET',
    endpoint: '/v3/volume/24h/all'
  });
  const totalVolume = Math.min(Number(idx(resultVolume, _ => _.payload.volume)) || 1781945);
  return (
    <StatsWrapper>
      <Container>
        <Grid text="center">
          <Col lg={6} sm={12}>
            <Margin vertical={24}>
              {!loadingVolume && <h1>{numeral(totalVolume).format('0,0')} IDRT</h1>}
              <p>{t('landing.stats.volume.description', 'Volume (24H)')}</p>
            </Margin>
          </Col>
          <Col lg={6} sm={12}>
            <Margin vertical={24}>
              {!loadingSupply && <h1>{numeral(totalSupply).format('0,0')} IDRT</h1>}
              <p>{t('landing.stats.supply.description', 'Circulating Supply')}</p>
            </Margin>
          </Col>
        </Grid>
        <div
          css={css`
            font-size: 10px;
            position: absolute;
            right: 12px;
            bottom: 0;
          `}
        >
          {t('landing.stats.supply.footnote', '*includes IDRTB, Binance Chain version of IDRT')}
        </div>
      </Container>
    </StatsWrapper>
  );
};

export default HomeStats;
